import { FC } from 'react'

import Button from 'common/components/button'
import { ReactComponent as Logout } from 'common/icons/logout/default.svg'

const LOGOUT_URL = process.env.REACT_APP_LOGOUT_URL
if (!LOGOUT_URL) {
  throw new Error(
    'REACT_APP_LOGOUT_URL environment variable is not set. Please set it to the logout URL.'
  )
}
const LogoutButton: FC = () => {
  return (
    <Button
      prefixIcon={<Logout width={24} height={24} />}
      variant="secondary"
      data-cy="logout-button"
      data-testid="logout-button"
      onClick={() => {
        window.location.href = LOGOUT_URL
      }}
    >
      Sign out
    </Button>
  )
}

export default LogoutButton
